import { Logger } from '../../../helpers/logger';
import { Env } from '../../../helpers/env';
import { LoggerStorageKey } from '../../../enums/loggerStorageKey';

// TODO set proper value for isDevelop
export const ShowThankYouPageLogger = new Logger(LoggerStorageKey.SHOW_THANK_YOU_PAGE_LOGGER, Env.isDevelop());
